export function customerIndexValidate(customer){
    var result = true;

    result = validateId(customer.id);
    if(!result) return result;

    result = validateName(customer.name);
    if(!result) return result;

    result = validateCountry(customer.country);
    if(!result) return result;

    result = validateState(customer.state);
    if(!result) return result;

    result = validateContactPhone(customer.contact_phone);
    if(!result) return result;

    result = validateRfidByProduct(customer.rfid_by_product);
    if(!result) return result;

    result = validateEmail(customer.email);
    if(!result) return result;

    result = validateClientType(customer.client_type);
    if(!result) return result;

    result = validateGuidesService(customer.guides_service);
    if(!result) return result;

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name) {
    if(typeof name == "string" && name != "") return true;
    else return false;
}

function validateCountry(country) {
    if(typeof country == "string") return true;
    else return false;
}

function validateState(state) {
    if(typeof state == "string") return true;
    else return false;
}

function validateContactPhone(contact_phone) {
    if(typeof contact_phone == "string") return true;
    else return false;
}

function validateRfidByProduct(rfid_by_product) {
    if(typeof rfid_by_product == "boolean") return true;
    else return false;
}

function validateEmail(email) {
    if(typeof email == "string" && email != "") return true;
    else return false;
}

function validateClientType(client_type) {
    if(typeof client_type == "string" && client_type != "") return true;
    else return false;
}

function validateGuidesService(guides_service) {
    if(typeof guides_service  == "boolean") return true;
    else return false;
}